import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  ListItemText,
  MenuItem,
  Modal,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Notifications } from "@material-ui/icons";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import BlockIcon from "@material-ui/icons/Block";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ShareIcon from '@material-ui/icons/OpenInNew';
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { format } from "date-fns";
import { debounce } from "lodash";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ActionMenu from "../../../common/ActionMenu";
import SearchBar from "../../../common/Search";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import AddNewUser from "../../../components/Dashboard/AddNewUser";
import {
  getCurrentUserEmail,
  isAdminLogin,
  isSuperAdminLogin,
  removeAuthObjects,
  toastError,
  toastSuccess,
} from "../../../utils";
import { generateObjectId } from "../UserList/AddUserForm";
import * as actions from "./actions";

// ─── STYLES & CONSTANTS ──────────────────────────────────────────────────────

const EMPTY_REQ_USER = {
  firstName: "",
  lastName: "",
  email: "",
  role: "user",
  moduleAccess: [],
  moduleHeads: {}
};



const inititalUser = {
  dateOfBirth: "",
  email: "",
  firstName: "",
  lastName: "",
  organizationId: "",
  password: "",
  role: "user",
  isPremium: false,
  isVerified: false,
  premiumAccessExpiry: "",
  isPaid: false,
  request: {},
  moduleAccess: [],
  moduleHeads: {}
};

const allAccess = [
  { id: 1, name: "Premium", value: "isPremium" },
  { id: 2, name: "Verified", value: "isVerified" },
];

export default function UserMgntOrg(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userOrganizaton = [], allOrganization = [] } = useSelector(
    (state) => state.dashboard
  );
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState({ ...inititalUser });
  const [isEdit, setIsEdit] = useState(false);
  const [isUserRequest, setisUserRequest] = useState(false);
  const [saveLabel, setSaveLabel] = useState("Add");
  const [selectedOrganization, setSelectedOrganization] = useState({});
  const [getForwardUser, setForwardUser] = useState("");
  const [requestCount, setrequestCount] = useState(0)
  const [searchValue, setSearchValue] = useState("");
  const [IsShowRequest, setIsShowRequest] = useState(false)
  const [showUserListModal, setShowUserListModal] = useState(false);
  const [userByOrganization, setUserByOrganization] = useState([]);
  const [DateRange, setDateRange] = useState({
    formattedStartDate: null,
    formattedEndDate: null,
  });
  const [editableUsers, setEditableUsers] = useState([]);

  // Head Management
  const [headModalOpen, setHeadModalOpen] = useState(false);
  const [activeUserIndex, setActiveUserIndex] = useState(null);

  const availableHeads = React.useMemo(() => {
    // 1. Collect heads from editableUsers with role "head" (most up-to-date data)
    const formHeads = editableUsers
      .filter((u) => u.role === "head" && u.firstName && u.email)
      .map((u) => ({
        _id: u._id,
        firstName: u.firstName,
        lastName: u.lastName,
        email: u.email,
        role: "head",
        moduleAccess: u.moduleAccess || [],
      }));

    // 2. Extract heads referenced in moduleHeads of ALL users in the request
    const referencedHeads = [];
    editableUsers.forEach((u) => {
      if (u.moduleHeads) {
        Object.values(u.moduleHeads).forEach((headArr) => {
          if (Array.isArray(headArr)) {
            headArr.forEach((h) => {
              if (h._id && !referencedHeads.find((rh) => rh._id === h._id)) {
                // Look up moduleAccess from userOrganizaton OR editableUsers (for UUID-based new users)
                const orgUser = userOrganizaton.find((ou) => ou._id === h._id)
                  || editableUsers.find((eu) => eu._id === h._id);
                referencedHeads.push({
                  _id: h._id,
                  firstName: h.firstName,
                  lastName: h.lastName,
                  email: h.email,
                  role: orgUser?.role || "head",
                  moduleAccess: orgUser?.moduleAccess || [],
                });
              }
            });
          }
        });
      }
    });

    // 3. Include the requesting user (superboss) in the heads list
    const requestingUser = userOrganizaton.find((u) => u._id === IsShowRequest);

    // 4. Merge: formHeads FIRST (have live moduleAccess), then referenced + requesting user
    const combined = [...formHeads];

    // Add requesting user (superboss) — always included
    if (requestingUser && !combined.find((ch) => ch._id === requestingUser._id)) {
      combined.push({
        _id: requestingUser._id,
        firstName: requestingUser.firstName,
        lastName: requestingUser.lastName,
        email: requestingUser.email,
        role: requestingUser.role,
        moduleAccess: requestingUser.moduleAccess || [],
      });
    }

    // Add any remaining referenced heads not already in combined
    referencedHeads.forEach((rh) => {
      if (!combined.find((ch) => ch._id === rh._id)) combined.push(rh);
    });

    return combined;
  }, [editableUsers, IsShowRequest, userOrganizaton]);

  const fetchUserOrganization = async () => {
    const res = await actions.getUsersForModulesHead({
      organizationId: user?.organizationId,
    });
    if (res) {
      setUserByOrganization(res.data || []);
      setUser({ ...user, userByOrganization: [] });
    }
  };

  useEffect(() => {
    if (user?.organizationId) fetchUserOrganization();
  }, [user?.organizationId]);


  const allRoles = [
    { id: 1, name: "User", value: "user" },
    { id: 2, name: "Head", value: "head" },
    { id: 3, name: "Super Boss", value: "superboss" },
  ];

  const [allFilters, setAllFilters] = useState({
    totalPages: 1,
    offset: 1,
    pageCount: 1,
    limit: 50
  });

  useEffect(() => {
    if (allOrganization.length)
      setSelectedOrganization(
        isSuperAdminLogin() ? "allUsers" : allOrganization[0]
      );
  }, [allOrganization]);

  useEffect(() => {
    if (selectedOrganization?._id) {
      setUser({
        ...user,
        organizationId: selectedOrganization?._id,
      });
      onUserForOrg();
    } else if (selectedOrganization === "allUsers") {
      onUserForOrg();
    }
  }, [selectedOrganization]);

  useEffect(() => {
    const currentItem = userOrganizaton.find(i => i._id === IsShowRequest);

    if (currentItem && currentItem.request?.users) {
      setEditableUsers(JSON.parse(JSON.stringify(currentItem.request.users)));
    }
  }, [IsShowRequest, userOrganizaton]);

  const onSearchUsers = async (search, selectedOrganization, formattedStartDate, formattedEndDate) => {
    try {
      const allUsers = !Object.keys(selectedOrganization).length || selectedOrganization === "allUsers";

      props.setLoader(true);

      const res = await dispatch(
        actions.usersForOrg({
          search,
          organizationId: selectedOrganization?._id,
          allUsers,
          userRequestOnly: isUserRequest,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        })
      );

      setrequestCount(res.data.requestCount);
      setAllFilters({
        totalPages: res?.data?.totalItems,
        offset: res?.data?.currentPage,
        pageCount: res?.data?.totalPages,
        limit: res?.data?.perPage,
      });
    } catch (err) {
      toastError(err?.data?.message);
    } finally {
      props.setLoader(false);
    }
  };

  const onSearchUser = useCallback((search, selectedOrganization, formattedStartDate, formattedEndDate) => {
    onSearchUsers(search, selectedOrganization, formattedStartDate, formattedEndDate);
  }, []);

  const delaySearch = useCallback(
    debounce((data, selectedOrganization, formattedStartDate, formattedEndDate) => {
      onSearchUser(data, selectedOrganization, formattedStartDate, formattedEndDate);
    }, 500),
    [onSearchUser]
  );

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    delaySearch(value, selectedOrganization, DateRange.formattedStartDate, DateRange.formattedEndDate);
  };

  const handleDateRangeChange = (newDateRange) => {
    const { startDate, endDate } = newDateRange;
    const formattedStartDate = startDate?.toISOString() || "";
    const formattedEndDate = endDate?.toISOString() || "";

    setDateRange((prev) => ({
      ...prev,
      formattedStartDate,
      formattedEndDate,
    }));

    delaySearch(searchValue, selectedOrganization, formattedStartDate, formattedEndDate);
  };

  const onUserForOrg = (search = '', selectedOrg, formattedStartDate = '', formattedEndDate = '') => {
    const allUsers = !Object.keys(selectedOrganization).length || selectedOrganization === "allUsers" || selectedOrg
    props.setLoader(true);
    dispatch(
      actions.usersForOrg({
        search: search || searchValue,
        organizationId: selectedOrganization?._id || selectedOrg?._id,
        allUsers: allUsers,
        userRequestOnly: isUserRequest,
        startDate: DateRange.formattedStartDate ?? formattedStartDate,
        endDate: DateRange.formattedEndDate ?? formattedEndDate,
      })
    )
      .then((res) => {
        setrequestCount(res.data.requestCount)
        setAllFilters({
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage
        })
        props.setLoader(false);
      })
      .catch((err) => {
        toastError(err?.data?.message);
        props.setLoader(false);
      });
  };

  const onCloseModal = (e) => {
    setUser({
      ...inititalUser,
      organizationId: selectedOrganization?._id,
    });
    setSaveLabel("Add");
    setOpen(false);
  };

  const onSubmitConfirm = () => {

    if (
      user.role === "user" &&
      Array.isArray(user?.moduleAccess) && user.moduleAccess.length > 0 &&
      user?.moduleHeads &&
      Object.values(user?.moduleHeads)?.length > 0 &&
      Object.values(user?.moduleHeads)?.every(arr => Array.isArray(arr) && arr.length === 0)
    ) {
      toastError("Please select a head for each module");
      return;
    }
    setOpen(false);
    props.setLoader(true);
    let newUser = { ...user, dateOfBirth: moment(user.dateOfBirth).format() };
    if (isEdit) {
      const updatedData = {
        userId: newUser._id,
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        email: newUser.email,
        forwardEmail: newUser?.forwardEmail,
        role: newUser.role,
        dateOfBirth: newUser.dateOfBirth,
        organizationId: newUser.organizationId,
        isPremium: newUser.isPremium,
        isVerified: newUser.isVerified,
        premiumAccessExpiry: newUser.premiumAccessExpiry,
        moduleAccess: newUser.moduleAccess,
        moduleHeads: newUser.moduleHeads,
      };
      if (updatedData.role === "superadmin") delete updatedData.role;
      return actions
        .updateUser(updatedData)
        .then(() => {
          toastSuccess("User Updated Successfully");
          props.setLoader(false);
          setShowUserListModal(false);
          onUserForOrg();
          setUser({
            ...inititalUser,
            organizationId: selectedOrganization?._id,
          });
          setIsEdit(false);
          setSaveLabel("Add");
        })
        .catch((err) => {
          toastError(err?.data?.message);
          props.setLoader(false);
          setOpen(true);
        });
    }
    actions
      .createUser(newUser)
      .then(() => {
        toastSuccess("User Created Successfully");
        props.setLoader(false);
        onUserForOrg();
        setUser({
          ...inititalUser,
          organizationId: selectedOrganization?._id,
        });
        setIsEdit(false);
        setSaveLabel("Add");
      })
      .catch((err) => {
        toastError(err?.data?.message);
        props.setLoader(false);
        setOpen(true);
      });
  };

  const onUpdateUserStatus = (status, item) => {
    const isActivated = status === "activate";
    props.setLoader(true);
    actions
      .updateActiveUser({ isActivated: isActivated, userId: item._id })
      .then(() => {
        props.setLoader(false);
        onUserForOrg();
        toastSuccess(
          `User ${isActivated ? "activated" : "deactivated"} Successfully`
        );
      })
      .catch((err) => {
        toastError(err?.data?.message);
        props.setLoader(false);
      });
  };

  const onEditUser = (item) => {
    const obj = {
      ...item,
      dateOfBirth: moment(item.dateOfBirth).valueOf(),
    };
    setForwardUser(obj?.forwardEmail)
    setUser(obj);
    setIsEdit(true);
    setSaveLabel("Update");
    setOpen(true);
    setIsShowRequest(false)
  };

  const onChangeOrganization = (id) => {
    let selectedOrganization =
      Array.isArray(allOrganization) && allOrganization.length
        ? allOrganization.find((org) => org._id === id)
        : {};
    setSelectedOrganization(selectedOrganization || id);
  };

  const onFunction = async (item, newValue) => {

    const updatedData = {
      userId: item._id,
      isPaid: newValue,
    };
    if (updatedData.role === "superadmin") delete updatedData.role;
    return actions
      .updateUser(updatedData)
      .then(() => {
        toastSuccess("User Updated Successfully");
        props.setLoader(false);
        onUserForOrg();
        setUser({
          ...inititalUser,
          organizationId: selectedOrganization?._id,
        });
        setIsEdit(false);
        setSaveLabel("Add");
      })
      .catch((err) => {
        toastError(err?.data?.message);
        props.setLoader(false);
        setOpen(true);
      });

  }

  const onChangeAllPagination = (type = "") => {
    let newallFilters = {}
    if (type === 'inc') {
      newallFilters = { ...allFilters, offset: allFilters.offset + 1 }
    } else if (type === 'first') {
      newallFilters = { ...allFilters, offset: 1 }
    } else {
      if (allFilters.offset === 1) return
      newallFilters = { ...allFilters, offset: allFilters.offset - 1 }
    }
    dispatch(
      actions.usersForOrg({
        ...newallFilters,
        organizationId: selectedOrganization?._id,
        allUsers: selectedOrganization === "allUsers",
        userRequestOnly: isUserRequest
      })
    )
      .then((res) => {

        setAllFilters({
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage
        })
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleNewUser = async (item, isRead) => {
    if (item.isRead) return
    const updatedData = {
      userId: item._id,
      isRead,
    };
    if (updatedData.role === "superadmin") delete updatedData.role;
    return actions
      .updateUser(updatedData)
      .then(() => {
        toastSuccess("User Updated Successfully");
        props.setLoader(false);
        onUserForOrg();
        setUser({
          ...inititalUser,
          organizationId: selectedOrganization?._id,
        });
        setIsEdit(false);
        setSaveLabel("Add");
      })
      .catch((err) => {
        toastError(err?.data?.message);
        props.setLoader(false);
        setOpen(true);
      });

  }

  const handleUserRequest = () => {
    const newIsUserRequest = !isUserRequest;
    setisUserRequest(newIsUserRequest);
    dispatch(
      actions.usersForOrg({
        organizationId: selectedOrganization?._id,
        allUsers: selectedOrganization === "allUsers",
        userRequestOnly: newIsUserRequest,
      })
    ).then((res) => {
      if (res) {
        setrequestCount(res.data.requestCount)
      }
    })
  };

  const onClickUserRedirect = async (id) => {
    try {
      const res = await actions.getUserRequest(id);
      if (res) {
        const currentUrl = window.location.origin;
        const newUrl = `${currentUrl}${res?.data}`
        if (res?.data) {
          try { await removeAuthObjects() } catch (err) { console.log(err) }
          window.open(newUrl, '_blank');
        }
      }
    } catch (err) {
      toastError(err?.data?.message);
    }
  }

  const handleEditChange = (index, field, value) => {
    const updated = [...editableUsers];
    const currentUser = updated[index];

    // If moduleAccess is changing for a head-role user, deselect them
    // from other users' moduleHeads for any removed modules
    if (field === "moduleAccess" && currentUser.role === "head") {
      const oldModules = currentUser.moduleAccess || [];
      const newModules = value || [];
      const removedModules = oldModules.filter((m) => !newModules.includes(m));
      if (removedModules.length > 0) {
        updated.forEach((u, i) => {
          if (i === index) return;
          removedModules.forEach((mod) => {
            if (u.moduleHeads?.[mod]?.some((h) => h._id === currentUser._id)) {
              updated[i] = {
                ...updated[i],
                moduleHeads: {
                  ...updated[i].moduleHeads,
                  [mod]: [],
                },
              };
            }
          });
        });
      }
    }

    updated[index][field] = value;

    // Auto-assign the requesting user (superboss) when role is changed to "head"
    if (field === "role" && value === "head") {
      const requestingUser = userOrganizaton.find((u) => u._id === IsShowRequest);
      if (requestingUser && updated[index].moduleAccess?.length > 0) {
        const newHeads = {};
        updated[index].moduleAccess.forEach((mod) => {
          newHeads[mod] = [
            {
              _id: requestingUser._id,
              firstName: requestingUser.firstName,
              lastName: requestingUser.lastName,
              email: requestingUser.email,
            },
          ];
        });
        updated[index].moduleHeads = newHeads;
      }
    }

    setEditableUsers(updated);
  };

  const handleRemoveUserFromRequest = (index) => {
    const updatedList = [...editableUsers];
    updatedList.splice(index, 1);
    setEditableUsers(updatedList);
  };

  const handleAddRow = (index) => {
    const currentUser = editableUsers[index];
    const newUsers = [...editableUsers];
    const newUser = {
      ...EMPTY_REQ_USER,
      _id: generateObjectId(),
      role: currentUser?.role || "user",
      moduleAccess: currentUser ? [...currentUser.moduleAccess] : [],
      moduleHeads: currentUser ? JSON.parse(JSON.stringify(currentUser.moduleHeads)) : {},
    };
    // Insert after current index
    newUsers.splice(index + 1, 0, newUser);
    setEditableUsers(newUsers);
  };

  const openHeadAssignment = (index) => {
    setActiveUserIndex(index);
    setHeadModalOpen(true);
  };

  const closeHeadAssignment = () => {
    setHeadModalOpen(false);
    setActiveUserIndex(null);
  };

  const handleHeadChange = (userIndex, moduleName, headId) => {
    const updatedUsers = [...editableUsers];
    const selectedHead = availableHeads.find((h) => h._id === headId);

    if (selectedHead) {
      updatedUsers[userIndex].moduleHeads = {
        ...updatedUsers[userIndex].moduleHeads,
        [moduleName]: [
          {
            _id: selectedHead._id,
            firstName: selectedHead.firstName,
            lastName: selectedHead.lastName,
            email: selectedHead.email,
          },
        ],
      };
    } else {
      // Clear head if needed
      updatedUsers[userIndex].moduleHeads = {
        ...updatedUsers[userIndex].moduleHeads,
        [moduleName]: [],
      };
    }
    setEditableUsers(updatedUsers);
  };

  const getHeadStatus = (user) => {
    if (!user.moduleAccess || user.moduleAccess.length === 0)
      return { status: "empty", label: "No Modules" };

    // Head-role users have auto-assigned superboss
    if (user.role === "head")
      return {
        status: "auto",
        label: "Auto (Boss)",
        width: "105px",
        color: "#4338CA", // indigo-700
        bg: "#EEF2FF", // indigo-50
        border: "#C7D2FE" // indigo-200
      };

    let missingCount = 0;
    user.moduleAccess.forEach((mod) => {
      if (
        !user.moduleHeads ||
        !user.moduleHeads[mod] ||
        user.moduleHeads[mod].length === 0
      ) {
        missingCount++;
      }
    });

    if (missingCount > 0)
      return {
        status: "pending",
        label: `${missingCount} Needed`,
        width: "100px",
        color: "#B45309", // amber-700
        bg: "#FFFBEB", // amber-50
        border: "#FDE68A" // amber-200
      };

    return {
      status: "complete",
      label: "Assigned",
      width: "90px",
      color: "#15803D", // green-700
      bg: "#F0FDF4", // green-50
      border: "#BBF7D0" // green-200
    };
  };

  const handleApproveBulkRequest = async (item) => {
    const finalUsersData = editableUsers;
    if (finalUsersData.length === 0) {
      toastError("No users to approve.");
      return;
    }
    try {
      props.setLoader(true);
      await actions.bulkCreateUsers({ requestBy: item._id, users: finalUsersData });
      toastSuccess("Users approved successfully");
      setIsShowRequest(false);
      onUserForOrg();
    } catch (err) {
      toastError(err?.message || "Failed to approve");
    } finally {
      props.setLoader(false);
    }
  };

  const handleRejectRequest = async (item) => {
    try {
      await actions.updateUserById({ data: { request: {} }, userId: item._id });
      setIsShowRequest(false);
      onUserForOrg();
    } catch (error) {
      toastError(error?.data?.message || "Failed to reject");
    }
  };

  return (
    <Grid container className="user-organization-contianer min-h-[calc(100vh-106px)]" alignContent="flex-start">
      <Grid item xs={12}>
        <Box className="flex flex-wrap justify-between items-center gap-2 mb-2">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="h-7 px-3 bg-white border border-slate-300 text-slate-800 rounded-none text-[11px] flex items-center gap-1.5 cursor-pointer hover:bg-slate-100 transition-colors"
          >
            <ArrowBackIosIcon className="text-[12px]" />
            Go back
          </button>

          <div className="flex flex-wrap items-center gap-2 w-full md:w-auto md:flex-1 md:justify-end">
            <div className="w-full md:w-auto desktop-searchbar">
              <SearchBar
                isMobile={false}
                placeholder="Search users..."
                setSearchValue={onSearchChange}
                searchValue={searchValue}
                onDateRangeChange={handleDateRangeChange}

              />
            </div>
            <div className="mobile-searchbar">
              <SearchBar
                isMobile
                placeholder="Search users..."
                setSearchValue={onSearchChange}
                searchValue={searchValue}
                onDateRangeChange={handleDateRangeChange}
              />
            </div>
            <div className="w-full md:w-[220px]">
              <FormControl variant="filled" size="small" fullWidth>
                <Select
                  value={selectedOrganization?._id || selectedOrganization}
                  onChange={(e) => onChangeOrganization(e.target.value)}
                  defaultValue="Single Freight"
                  size="small"
                  variant="outlined"
                  fullWidth
                  className="h-7 text-[11px] bg-white rounded-none"
                  inputProps={{ "aria-label": "Filter by organization" }}
                  MenuProps={{ PaperProps: { className: "admin-form-menu" } }}
                >
                  {isSuperAdminLogin() && (
                    <MenuItem dense value={"allUsers"}>All Users</MenuItem>
                  )}
                  {Array.isArray(allOrganization) &&
                    allOrganization.map((item, index) => (
                      <MenuItem key={index} dense value={item._id}>
                        {item.organizationName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </div>

          <div className="flex gap-2 items-center w-full md:w-auto">
            <button
              type="button"
              className={`h-7 px-2 border rounded-none text-[11px] flex items-center justify-center gap-1.5 cursor-pointer transition-colors ${isUserRequest ? "border-[#313C4C] bg-[#313C4C] text-white" : "border-slate-300 bg-white text-slate-700 hover:bg-slate-100"}`}
              onClick={handleUserRequest}
              aria-pressed={isUserRequest}
              title={isUserRequest ? "Show all users" : "Show user requests"}
            >
              <Notifications className="text-[14px] text-inherit" />
              Requests
              <span className="min-w-[18px] h-[18px] px-1 bg-slate-100 text-slate-700 rounded-full text-[10px] inline-flex items-center justify-center tabular-nums">{requestCount ?? 0}</span>
              {isUserRequest && <RxCross2 size={12} aria-hidden="true" />}
            </button>

            <button
              type="button"
              onClick={() => { setIsEdit(false); setOpen(true); }}
              className="h-7 px-3 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] rounded-none whitespace-nowrap transition-colors"
            >
              Create User
            </button>
          </div>
        </Box>
      </Grid>


      <Grid item xs={12}>
        <Box>
          <TableContainer component={Paper} className="!shadow-sm !rounded-none overflow-x-auto scroll-thin">
            {allFilters?.totalPages > allFilters?.limit && (
              <CustomPagination
                onChangePagination={onChangeAllPagination}
                filters={allFilters}
                totalPage={allFilters?.totalPages}
              />
            )}
            <Table className="universal-table">
              <TableHead>
                <TableRow className="bg-gray-100 ">
                  <TableCell className="font-semibold ">S.No</TableCell>
                  <TableCell className="font-semibold ">Name</TableCell>
                  <TableCell className="font-semibold ">Email</TableCell>
                  <TableCell className="font-semibold ">Role</TableCell>
                  <TableCell className="font-semibold text-center">Status</TableCell>
                  <TableCell className="font-semibold text-center">Paid</TableCell>
                  <TableCell className="font-semibold text-center">Created on</TableCell>
                  <TableCell className="font-semibold text-center">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {Array.isArray(userOrganizaton) && userOrganizaton.length ? (
                  userOrganizaton.map((item, index) => {
                    const isEvenRow = index % 2 === 0;
                    return (
                      <TableRow
                        key={index}
                        className={`h-7 cursor-pointer ${item.request ? "bg-rose-200" : item.isRead ? (isEvenRow ? "bg-gray-200" : "bg-white") : "bg-sky-100"}`}
                        onClick={() => handleNewUser(item, true)}
                        onDoubleClick={() => onEditUser(item)}
                      >

                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          {[item.firstName, item.lastName].filter(Boolean).join(" ")}
                        </TableCell>

                        <TableCell className="text-gray-600">{item.email}</TableCell>

                        <TableCell className="capitalize text-gray-600">{item.role}</TableCell>

                        <TableCell>
                          <span
                            className={`inline-flex h-[20px] min-w-[64px] items-center justify-center border px-2 text-[11px] font-medium whitespace-nowrap ${item.isActivated
                              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                              : "bg-slate-100 text-slate-600 border-slate-300"
                              }`}
                          >
                            {item.isActivated ? "Active" : "Inactive"}
                          </span>
                        </TableCell>

                        <TableCell className="text-center">
                          <div>
                            <Switch
                              size="small"
                              checked={item?.isPaid}
                              onChange={(event) => onFunction(item, event.target.checked)}
                              color="primary"
                              inputProps={{ "aria-label": `Paid access for ${item.firstName || item.email}` }}
                            />
                          </div>
                        </TableCell>
                        <TableCell className="text-center">{moment(item?.createdAt).format("DD/MMM/yyyy")}</TableCell>

                        <TableCell className="user-organization-actions">
                          {item.email !== getCurrentUserEmail() && (
                            <div className="flex items-center justify-center gap-1">
                              <ActionMenu
                                options={[
                                  {
                                    label: "Edit",
                                    onClick: () => onEditUser(item),
                                    icon: <EditIcon className={isSuperAdminLogin() ? "!text-slate-600" : "text-lightBlue"} />,
                                  },
                                  {
                                    label: "Activate",
                                    icon: isSuperAdminLogin() && <CheckCircleIcon className="!text-emerald-600" />,
                                    onClick: () => onUpdateUserStatus("activate", item),
                                    hide: item.role === "superadmin" || item.isActivated,
                                  },
                                  {
                                    label: "Deactivate",
                                    icon: isSuperAdminLogin() && <BlockIcon className="!text-rose-600" />,
                                    onClick: () => onUpdateUserStatus("deactivate", item),
                                    hide: item.role === "superadmin" || !item.isActivated,
                                  },
                                ]}
                              />
                              <button title="Open user account" aria-label="Open user account" onClick={() => { setIsShowRequest(item?._id); onClickUserRedirect(item?._id, item); }} className="p-1 text-[#313C4C] hover:bg-slate-100">
                                <ShareIcon
                                  style={{
                                    color: "black",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                  }}
                                />
                              </button>
                              {item.request && (
                                <>
                                  <button title="Review user request" aria-label="Review user request" onClick={() => setIsShowRequest(item?._id)} className="p-1 text-[#313C4C] hover:bg-slate-100 transition-colors">
                                    <Notifications className="text-[16px]" />
                                  </button>

                                  <Modal
                                    open={IsShowRequest === item?._id}
                                    onClose={() => setIsShowRequest(false)}
                                    aria-labelledby="modal-title"
                                    className="flex items-center justify-center z-[999]"
                                  >
                                    <div role="dialog" aria-modal="true" aria-labelledby="modal-title" className="superadmin-dialog bg-white border border-slate-200 shadow-2xl w-[1100px] max-w-[96vw] max-h-[90vh] flex flex-col outline-none overflow-hidden">

                                      <div className="flex items-center justify-between px-3 py-2 border-b border-slate-200 bg-slate-50">
                                        <div>
                                          <Typography id="modal-title" variant="h6" className="text-[14px] font-medium text-slate-900">
                                            {item.request?.type === "requestUsers" ? "Review User Request" : "Notification Details"}
                                          </Typography>
                                        </div>
                                        <button
                                          onClick={() => setIsShowRequest(false)}
                                          aria-label="Close request details"
                                          className="text-slate-500 hover:text-slate-900 transition-colors p-1 hover:bg-slate-100"
                                        >
                                          <IoCloseCircleOutline className="text-[16px]" />
                                        </button>
                                      </div>

                                      <div className="p-3 overflow-y-auto scroll-thin">
                                        {item.request?.type === "requestUsers" ? (
                                          <div className="space-y-3">

                                            <div className="flex flex-col sm:flex-row gap-2 justify-between bg-slate-50 border border-slate-200 p-2">
                                              <div className="flex items-start gap-2">
                                                <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center text-slate-700 font-medium shrink-0 text-[11px]">
                                                  {item.firstName?.[0]}{item.lastName?.[0]}
                                                </div>
                                                <div>
                                                  <Typography variant="subtitle2" className="text-[12px] text-slate-900 font-medium">
                                                    {item.firstName} {item.lastName}
                                                  </Typography>
                                                  <p className="text-[11px] text-slate-600 mt-0.5">
                                                    {item.email}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="flex flex-col items-start sm:items-end justify-center gap-0.5">
                                                <span className="text-[10px] uppercase text-slate-500 tracking-wide">Request Date</span>
                                                <span className="text-[11px] font-medium text-slate-700">
                                                  {item.request.createdAt ? format(new Date(item.request.createdAt), "MMM d, yyyy • h:mm a") : "-"}
                                                </span>
                                              </div>
                                            </div>

                                            <div className="border border-slate-200 bg-white p-2">
                                              <p className="text-[11px] font-medium text-slate-700 mb-1">Attached Note</p>
                                              {item.request.reason ? (
                                                <p className="text-slate-700 text-[11px] leading-relaxed whitespace-pre-wrap break-words">"{item.request.reason}"</p>
                                              ) : (
                                                <p className="text-slate-500 text-[11px]">No additional notes provided.</p>
                                              )}
                                            </div>

                                            <div className="border border-slate-300 overflow-hidden">
                                              <div className="bg-slate-50 px-2 py-2 border-b border-slate-200 flex flex-wrap gap-2 justify-between items-center">
                                                <span className="text-[11px] font-medium text-slate-700">Requested Users ({editableUsers.length})</span>
                                                <span className="text-[11px] text-slate-500">Review user details before approving</span>
                                              </div>
                                              <TableContainer className="admin-form max-h-[350px] overflow-auto scroll-thin">
                                                <Table size="small" stickyHeader className="min-w-[960px] [&_th]:text-[11px] [&_td]:text-[11px]">
                                                  <TableHead>
                                                    <TableRow>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="50px">Add</TableCell>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="16%">First Name</TableCell>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="16%">Last Name</TableCell>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="20%">Email</TableCell>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="12%">Role</TableCell>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="18%">Modules</TableCell>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="14%">Heads</TableCell>
                                                      <TableCell className="font-medium bg-slate-100 text-slate-700 px-2 py-2" width="50px">Remove</TableCell>
                                                    </TableRow>
                                                  </TableHead>
                                                  <TableBody>
                                                    {editableUsers.map((reqUser, rIndex) => {
                                                      const headStatus = getHeadStatus(reqUser);
                                                      return (
                                                        <TableRow key={rIndex} className="hover:bg-slate-50 transition-colors">
                                                          <TableCell className="px-2 py-1 text-center">
                                                            <Tooltip title="Add row below">
                                                              <IconButton
                                                                size="small"
                                                                onClick={() => handleAddRow(rIndex)}
                                                                aria-label="Add user row below"
                                                                className="text-sky-500 hover:bg-sky-50"
                                                              >
                                                                <AddCircleIcon style={{ fontSize: 18 }} />
                                                              </IconButton>
                                                            </Tooltip>
                                                          </TableCell>

                                                          <TableCell className="px-2 py-1">
                                                            <TextField
                                                              value={reqUser.firstName}
                                                              onChange={(e) => handleEditChange(rIndex, 'firstName', e.target.value)}
                                                              variant="outlined" size="small" fullWidth
                                                              className="bg-white"
                                                              inputProps={{ "aria-label": `First name for requested user ${rIndex + 1}` }}
                                                            />
                                                          </TableCell>

                                                          <TableCell className="px-2 py-1">
                                                            <TextField
                                                              value={reqUser.lastName}
                                                              onChange={(e) => handleEditChange(rIndex, 'lastName', e.target.value)}
                                                              variant="outlined" size="small" fullWidth
                                                              className="bg-white"
                                                              inputProps={{ "aria-label": `Last name for requested user ${rIndex + 1}` }}
                                                            />
                                                          </TableCell>

                                                          <TableCell className="px-2 py-1">
                                                            <TextField
                                                              value={reqUser.email}
                                                              onChange={(e) => handleEditChange(rIndex, 'email', e.target.value)}
                                                              variant="outlined" size="small" fullWidth
                                                              className="bg-white"
                                                              inputProps={{ "aria-label": `Email for requested user ${rIndex + 1}` }}
                                                            />
                                                          </TableCell>

                                                          <TableCell className="px-2 py-1">
                                                            <Select
                                                              value={reqUser.role}
                                                              onChange={(e) => handleEditChange(rIndex, 'role', e.target.value)}
                                                              inputProps={{ 'aria-label': `Role for requested user ${rIndex + 1}` }}
                                                              variant="outlined" margin="dense" fullWidth
                                                              className="bg-white h-8 text-[11px]"
                                                              MenuProps={{ PaperProps: { className: "admin-form-menu" } }}
                                                            >
                                                              <MenuItem value="user">User</MenuItem>
                                                              <MenuItem value="head">Head</MenuItem>
                                                            </Select>
                                                          </TableCell>

                                                          <TableCell className="px-2 py-1">
                                                            <Select
                                                              multiple
                                                              value={reqUser.moduleAccess || []}
                                                              onChange={(e) => handleEditChange(rIndex, 'moduleAccess', e.target.value)}
                                                              inputProps={{ 'aria-label': `Modules for requested user ${rIndex + 1}` }}
                                                              variant="outlined" margin="dense" fullWidth
                                                              className="bg-white h-8 w-full text-[11px]"
                                                              renderValue={(selected) => (
                                                                <div className="flex flex-wrap gap-1 overflow-hidden h-full w-full items-center px-1">
                                                                  {selected.length > 0 ? (
                                                                    <span className="text-[11px] font-medium bg-slate-100 px-1 py-0.5">
                                                                      {selected.length} Selected
                                                                    </span>
                                                                  ) : <span className="text-slate-500 text-[11px]">None</span>}
                                                                </div>
                                                              )}
                                                              MenuProps={{ PaperProps: { className: "admin-form-menu", style: { maxHeight: 250 } } }}
                                                            >
                                                              {["chartering", "operations", "accounts", "agency", "shipmanagament", "admin", "riskmanagement", "fuelsupply", "knowledgepartner"].map((name) => (
                                                                <MenuItem key={name} value={name} dense className="hover:bg-sky-50">
                                                                  <Checkbox
                                                                    checked={reqUser.moduleAccess?.indexOf(name) > -1}
                                                                    size="small"
                                                                    color="primary"
                                                                  />
                                                                  <ListItemText primary={name} primaryTypographyProps={{ className: 'text-[11px]' }} />
                                                                </MenuItem>
                                                              ))}
                                                            </Select>
                                                          </TableCell>

                                                          <TableCell className="px-2 py-1 text-center">
                                                            <Button
                                                              onClick={() => openHeadAssignment(rIndex)}
                                                              disabled={!reqUser.moduleAccess || reqUser.moduleAccess.length === 0 || reqUser.role === "head"}
                                                              size="small"
                                                              variant="outlined"
                                                              style={{
                                                                textTransform: "none",
                                                                minWidth: headStatus.width,
                                                                fontSize: "11px",
                                                                padding: "2px 8px",
                                                                color: headStatus.color,
                                                                borderColor: headStatus.border,
                                                                background: headStatus.bg,
                                                                fontWeight: 500
                                                              }}
                                                              startIcon={
                                                                headStatus.status === "auto" ? <SupervisorAccountIcon style={{ fontSize: 14 }} /> :
                                                                  headStatus.status === "complete" ? <CheckCircleIcon style={{ fontSize: 14 }} /> :
                                                                    headStatus.status === "pending" ? <ErrorOutlineIcon style={{ fontSize: 14 }} /> :
                                                                      <SupervisorAccountIcon style={{ fontSize: 14 }} />
                                                              }
                                                            >
                                                              {headStatus.label}
                                                            </Button>
                                                          </TableCell>

                                                          <TableCell className="px-2 py-1 text-center">
                                                            <Tooltip title="Remove this user">
                                                              <IconButton
                                                                size="small"
                                                                onClick={() => handleRemoveUserFromRequest(rIndex)}
                                                                aria-label="Remove requested user"
                                                                className="hover:bg-rose-50"
                                                              >
                                                                <DeleteOutlineIcon className="text-rose-400 hover:text-rose-600" fontSize="small" />
                                                              </IconButton>
                                                            </Tooltip>
                                                          </TableCell>
                                                        </TableRow>
                                                      );
                                                    })}
                                                  </TableBody>
                                                </Table>
                                              </TableContainer>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="flex flex-col items-center justify-center py-4 text-center space-y-3">
                                            <div className="w-10 h-10 bg-slate-100 rounded-full flex items-center justify-center">
                                              <Notifications className="text-slate-500 text-[20px]" />
                                            </div>
                                            <div>
                                              <h3 className="text-[14px] font-medium text-slate-800">
                                                Request from {item.firstName} {item.lastName}
                                              </h3>
                                              <p className="text-[11px] text-slate-500 mt-1">
                                                Received on {item.request.createdAt ? format(new Date(item.request.createdAt), "MMMM d, yyyy • h:mm a") : "-"}
                                              </p>
                                            </div>

                                            <div className="bg-slate-50 p-3 border border-slate-200 max-w-md w-full text-left">
                                              <span className="text-[11px] font-medium text-slate-500 block mb-1">Message / Reason</span>
                                              <p className="text-[11px] text-slate-700 whitespace-pre-wrap break-words">"{item.request.reason}"</p>
                                            </div>
                                          </div>
                                        )}
                                      </div>

                                      <div className="bg-slate-50 px-3 py-2 border-t border-slate-200 flex flex-wrap justify-end gap-2 shrink-0">
                                        {item.request?.type === "requestUsers" ? (
                                          <>
                                            <Button
                                              onClick={() => handleRejectRequest(item)}
                                              variant="outlined"
                                              color="secondary"
                                              className="h-7 rounded-none border-rose-200 text-rose-700 hover:bg-rose-50 hover:border-rose-300 normal-case px-3 text-[11px] font-medium"
                                            >
                                              Reject Request
                                            </Button>
                                            <Button
                                              onClick={() => handleApproveBulkRequest(item)}
                                              disabled={editableUsers.length === 0}
                                              variant="contained"
                                              className={`h-7 rounded-none shadow-none normal-case px-3 text-[11px] font-medium ${editableUsers.length === 0 ? 'bg-slate-200 text-slate-500' : 'bg-[#313C4C] hover:bg-[#1e2632] text-white'}`}
                                            >
                                              Approve & Create Users
                                            </Button>
                                          </>
                                        ) : (
                                          <Button
                                            onClick={() => setIsShowRequest(false)}
                                            variant="outlined"
                                            className="h-7 rounded-none border-slate-300 text-slate-700 hover:bg-slate-100 normal-case px-3 text-[11px]"
                                          >
                                            Close
                                          </Button>
                                        )}
                                      </div>
                                    </div>
                                  </Modal>
                                </>
                              )}
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={8} className="!bg-white">
                      No User organization found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

            </Table>
            {allFilters?.totalPages > allFilters?.limit && (
              <CustomPagination

                onChangePagination={onChangeAllPagination}
                filters={allFilters}
                totalPage={allFilters?.totalPages}
              />
            )}
          </TableContainer>
        </Box>
      </Grid >
      {open ?
        <CustomAddModal
          open={open}
          saveLabel={saveLabel}
          title={isEdit ? "Update User" : "Add User"}
          handleClose={onCloseModal}
          onSubmitConfirm={onSubmitConfirm}
        >
          <AddNewUser
            user={user}
            getForwardUser={getForwardUser}
            isEdit={isEdit}
            allRoles={allRoles}
            allAccess={allAccess}
            setUser={setUser}
            userByOrganization={userByOrganization}
            selectedOrganization={selectedOrganization}
            onChangeOrganization={onChangeOrganization}
            isAdminLogin={isAdminLogin}
            isSuperAdminLogin={isSuperAdminLogin}
            allOrganization={allOrganization}
          />
        </CustomAddModal>
        : ""}
      {/* Head assignment uses the same form layout as add/edit user. */}
      {activeUserIndex !== null && headModalOpen && (
        <CustomAddModal
          open={headModalOpen}
          handleClose={closeHeadAssignment}
          onClose={closeHeadAssignment}
          onSubmitConfirm={closeHeadAssignment}
          title="Assign Module Heads"
          saveLabel="Done"
          maxWidth="sm"
        >
          <div className="admin-form flex flex-col gap-3">
            {editableUsers[activeUserIndex]?.moduleAccess.length === 0 ? (
              <div className="p-3 text-center text-[11px] text-slate-500">
                No modules selected for this user.
              </div>
            ) : (
              editableUsers[activeUserIndex]?.moduleAccess.map((mod) => {
                const headArr = editableUsers[activeUserIndex].moduleHeads?.[mod] || [];
                const currentHeadId = headArr.length > 0 ? headArr[0]._id : "";
                const modLabel = mod.charAt(0).toUpperCase() + mod.slice(1);
                const currentUser = editableUsers[activeUserIndex];

                return (
                  <div key={mod} className="grid grid-cols-1 sm:grid-cols-[120px_1fr] items-center gap-1.5 sm:gap-3">
                    <label id={`request-head-${mod}`} className="text-[11px] text-slate-700">{modLabel}</label>
                    <FormControl fullWidth size="small" variant="outlined">
                      <Select
                        key={`${mod}-${availableHeads.length}`}
                        labelId={`request-head-${mod}`}
                        value={currentHeadId || ""}
                        displayEmpty
                        onChange={(e) => handleHeadChange(activeUserIndex, mod, e.target.value)}
                        className="bg-white rounded-none text-[11px]"
                        MenuProps={{ PaperProps: { className: "admin-form-menu", style: { maxHeight: 260 } } }}
                      >
                        <MenuItem value="">Select a head</MenuItem>
                        {availableHeads
                          ?.filter((h) => h._id !== currentUser._id)
                          .filter((h) => h.role === "superboss" || h.moduleAccess?.includes(mod))
                          .map((h) => (
                            <MenuItem key={h._id} value={h._id} className="text-[11px]">
                              {h.firstName} {h.lastName} ({h.email})
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                );
              })
            )}
          </div>
        </CustomAddModal>
      )}

    </Grid >
  );
}
